.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: var(--tuna-spacing-1, 8px);
}

.body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.empty {
  color: var(--tuna-palette-text-secondary);
  padding: var(--tuna-spacing-2, 16px);
}
